import React from "react";
import { siteData } from "../data/mockData";
import { Phone, MapPin, Clock, ArrowUpRight } from "lucide-react";

const Footer = () => {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* Main Footer */}
      <footer className="w-full bg-[#1CA0B9] pt-14 pb-6 px-6 md:px-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 pb-10 border-b border-white/20">

            {/* Col 1: Logo + About */}
            <div className="md:col-span-4">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src="/logo_white.png"
                  alt="Anish Total Dental Care"
                  className="w-11 h-11 object-contain"
                />
                <div className="flex flex-col">
                  <span className="font-poppins font-bold text-white text-lg leading-tight">
                    Anish Total
                  </span>
                  <span className="font-poppins text-white/70 text-sm leading-tight">
                    Dental Care
                  </span>
                </div>
              </div>
              <p className="font-poppins text-white/80 text-sm leading-relaxed max-w-xs">
                Serving Erode with global-standard dental care since 2000. Your smile is our passion.
              </p>
            </div>

            {/* Col 2: Quick Links */}
            <div className="md:col-span-2">
              <h4 className="font-poppins font-semibold text-white text-sm uppercase tracking-wider mb-5">
                Quick Links
              </h4>
              <ul className="flex flex-col gap-3">
                {[
                  { label: "Home", id: "home" },
                  { label: "Services", id: "services" },
                  { label: "About Us", id: "about" },
                ].map((link) => (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollToSection(link.id)}
                      className="font-poppins text-white/80 text-sm hover:text-white transition-colors bg-transparent border-none cursor-pointer flex items-center gap-1 group"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 3: Clinic Hours */}
            <div className="md:col-span-3">
              <h4 className="font-poppins font-semibold text-white text-sm uppercase tracking-wider mb-5">
                Clinic Hours
              </h4>
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <p className="font-poppins text-white/90 text-sm font-medium">Morning</p>
                    <p className="font-poppins text-white/70 text-xs">10:00 AM – 1:30 PM</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <p className="font-poppins text-white/90 text-sm font-medium">Evening</p>
                    <p className="font-poppins text-white/70 text-xs">5:00 PM – 8:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Col 4: Contact + Map */}
            <div className="md:col-span-3">
              <h4 className="font-poppins font-semibold text-white text-sm uppercase tracking-wider mb-5">
                Find Us
              </h4>

              {/* Mini Map */}
              <div className="w-full h-[130px] rounded-lg overflow-hidden mb-4 border border-white/20">
                <iframe
                  title="Anish Total Dental Care Location"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15647.885084100044!2d77.718095!3d11.336809!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96f3e5d4f282d%3A0x3fc44f46395a12b7!2sAnish%20Total%20Dental%20Care%20Centre!5e0!3m2!1sen!2sin!4v1774529588080!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>

              <a
                href={siteData.clinic.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 text-white/80 hover:text-white transition-colors mb-3"
              >
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span className="font-poppins text-xs leading-relaxed">
                  277, Opp. Power House, EVN Rd, Erode, Tamil Nadu 638009
                </span>
              </a>

              <a
                href={`tel:${siteData.clinic.phone}`}
                className="flex items-center gap-2 text-white/80 hover:text-white transition-colors mb-2"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="font-poppins text-xs">0424 224 0802</span>
              </a>

              <a
                href="tel:+919751203819"
                className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="font-poppins text-xs">+91 97512 03819</span>
              </a>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-5 flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="font-poppins text-white/70 text-xs">
              &copy; {new Date().getFullYear()} Anish Total Dental Care. All rights reserved.
            </p>
            <p className="font-poppins text-white/50 text-xs">
              Designed with care for your smile
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
